export const contactsData = {
  email: "suleman@apportunity.io",
  phone: "(408) 601-7007",
  address: "Sacramento, CA 95608, United States",
  sheetAPI: "https://sheetdb.io/api/v1/92ngu3evrax5j",
  calendly: "https://www.calendly.com/apportunity"
};
